'use client';

import { useEffect, useState } from 'react';
import { Logo } from './icons';
import { WhiteLogo } from './white-logo';
import { cn } from '@/lib/utils';

interface DynamicLogoProps {
    className?: string;
    invert?: boolean;
}

export function DynamicLogo({ className, invert = false }: DynamicLogoProps) {
    const [isDarkMode, setIsDarkMode] = useState(false);

    useEffect(() => {
        // Function to check and set the theme
        const checkTheme = () => {
            const isDark = document.documentElement.classList.contains('dark');
            setIsDarkMode(isDark);
        };

        // Initial check
        checkTheme();

        // Use a MutationObserver to watch for class changes on the <html> element
        const observer = new MutationObserver(checkTheme);
        observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

        // Cleanup observer on component unmount
        return () => observer.disconnect();
    }, []);

    const showWhiteLogo = invert ? !isDarkMode : isDarkMode;

    return showWhiteLogo ? <WhiteLogo className={cn(className)} /> : <Logo className={cn(className)} />;
}
